'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _enhancer = require('./enhancer');

var _enhancer2 = _interopRequireDefault(_enhancer);

var _plugins = require('./plugins');

var _plugins2 = _interopRequireDefault(_plugins);

var _componentsPrintStyleSheet = require('./components/print-style-sheet');

var _componentsPrintStyleSheet2 = _interopRequireDefault(_componentsPrintStyleSheet);

var _componentsStyle = require('./components/style');

var _componentsStyle2 = _interopRequireDefault(_componentsStyle);

var _getState = require('./get-state');

var _getState2 = _interopRequireDefault(_getState);

var _keyframes = require('./keyframes');

var _keyframes2 = _interopRequireDefault(_keyframes);

var _resolveStyles = require('./resolve-styles');

function Radium(ComposedComponent /*: constructor*/) {
  return _enhancer2['default'](ComposedComponent);
}

Radium.Plugins = _plugins2['default'];
Radium.PrintStyleSheet = _componentsPrintStyleSheet2['default'];
Radium.Style = _componentsStyle2['default'];
Radium.getState = _getState2['default'];
Radium.keyframes = _keyframes2['default'];
Radium.__clearStateForTests = _resolveStyles.__clearStateForTests;

exports['default'] = Radium;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/radium/lib/index.js
 ** module id = 43
 ** module chunks = 0
 **/